import Vue from 'vue';

/** Event bus for sending DNS events. */
const DomainEventBus = new Vue();

export default DomainEventBus;
